import { FileCategories } from '@/constants/backend/FileCategories'
import { getUrl } from '@/utils/file'
import { parseJson } from '@/utils/parser'

export default class File {
  id: number | string
  created_at: string
  name: string
  filename: string
  ext: string
  source: string
  path: string
  description: string
  category: number
  meta: any

  constructor(data: Partial<File>) {
    Object.assign(this, {
      id: data.id || '',
      created_at: data.created_at,
      name: data.name,
      filename: data.filename,
      ext: data.ext,
      source: data.source,
      path: data.path,
      description: data.description,
      category: data.category || FileCategories.CAT_IMG_ORIGINAL,
      meta: data.meta,
    })
  }

  static fromServer(data: LX.File) {
    return new File({
      ...data,
      category: data.category,
    })
  }

  get src() {
    return getUrl(this)
  }

  get parsedMeta() {
    return parseJson(this.meta)
  }
}
